import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()

export class IdWatchService {
	FORM_URI: string = environment.apiUrl + '/form';

	constructor(private route: ActivatedRoute) {
	}

	get idChange(): Observable<string> {
		
		//return this.route.queryParams.pipe(map(p => p.id));
		return this.route.params.map(p => p['id'] ).distinctUntilChanged();
		// this.route.params.map(p => p['id'] as number | undefined).distinctUntilChanged();
		 
	  }


}



// WEBPACK FOOTER //
// ./src/app/services/watch.service.ts